import { createColDef } from '@fortem-monorepo/react-ag'

import { DateCellEditor } from '@/ag-grid/columns/instruction-date/cell-editor'
import { DateCellRenderer } from '@/ag-grid/columns/instruction-date/renderer'

export const instruction_date = createColDef({
  field: 'instruction_date',
  headerName: 'Instruction Date',
  cellEditor: DateCellEditor,
  cellRenderer: DateCellRenderer,
  cellClass: 'text-center',
})
